import { TitleAdjusted } from "../log-book-item-form-dialog/FormsStyled";
import FileList from "../log-sheet/log-sheet-form/FileList";
import { LinksList } from "../log-sheet/log-sheet-form/LinksList";

export const AttachmentSection = () => {
  return (
    <>
      <TitleAdjusted data-testid="action-data-title-2">External Links and Files</TitleAdjusted>
      <div style={{ display: "flex", flexDirection: "column", gridColumn: "1/5" }}>
        <div style={{ display: "flex", gap: "8px" }}>
          <LinksList />
          <FileList />
        </div>
      </div>
    </>
  );
};
